// Marketplace ratings & reviews — the data-testid registry.
//
// The frontend lane renders these; the jest suites and the browser journey
// (`scripts/browser_qa/marketplace_reviews_journey.py`) read them. Parameterised ids are
// functions of the row id or tenant id so the two sides cannot disagree on a separator.
// Contract: docs/marketplace-module/reviews-api-contract.md §12.

export const REVIEWS = Object.freeze({
  // marketplace card (MarketplaceLearn.jsx)
  cardRating: (tenantId) => `practitioner-rating-${tenantId}`,
  cardRatingNew: (tenantId) => `practitioner-rating-new-${tenantId}`,
  cardProfileLink: (tenantId) => `practitioner-profile-${tenantId}`,

  // practitioner profile page (MarketplacePractitioner.jsx)
  profilePage: "marketplace-practitioner-page",
  profileNotFound: "marketplace-practitioner-not-found",
  profileLoadError: "marketplace-practitioner-load-error",
  profileVisitSite: "marketplace-practitioner-visit-site",
  profileCard: "marketplace-practitioner-card",
  profileBook: "marketplace-practitioner-book",
  profileSiteHost: "marketplace-practitioner-site-host",
  profileAbout: "marketplace-practitioner-about",
  profilePhoto: "marketplace-practitioner-photo",
  profileHeadline: "marketplace-practitioner-headline",
  profileContact: "marketplace-practitioner-contact",
  profileFacts: "marketplace-practitioner-facts",
  profileFact: (key) => `marketplace-practitioner-fact-${key}`,
  profileBio: "marketplace-practitioner-bio",
  cardVisitSite: (tenantId) => `practitioner-visit-site-${tenantId}`,
  profileService: (serviceId) => `practitioner-service-${serviceId}`,
  profileServiceBook: (serviceId) => `practitioner-service-book-${serviceId}`,
  ratingSummary: "rating-summary",
  ratingHistogramRow: (stars) => `rating-histogram-${stars}`,
  ratingSubAvg: (key) => `rating-sub-${key}`,
  reviewsList: "reviews-list",
  reviewsEmpty: "reviews-empty",
  reviewsLoadError: "reviews-load-error",
  reviewRow: (id) => `review-row-${id}`,
  reviewReply: (id) => `review-reply-${id}`,
  reviewsPagerNext: "reviews-pager-next",
  reviewsPagerPrev: "reviews-pager-prev",

  // review form (ReviewForm.jsx at /avis)
  form: "review-form",
  formMissingToken: "review-form-missing-token",
  formLoadError: "review-form-load-error",
  formRefusal: "review-form-refusal",
  formExpired: "review-form-expired",
  formSubmitted: "review-form-submitted",
  formDisabled: "review-form-disabled",
  formContext: "review-form-context",
  formStar: (n) => `review-star-${n}`,
  formSubStar: (key, n) => `review-sub-${key}-star-${n}`,
  formText: "review-form-text",
  formTextCounter: "review-form-text-counter",
  formSubmit: "review-form-submit",
  formError: "review-form-error",
  formMarketplaceLink: "review-form-marketplace-link",

  // client portal + consult exit screen
  portalCta: (bookingId) => `booking-review-${bookingId}`,
  portalDone: (bookingId) => `booking-reviewed-${bookingId}`,
  roomInvite: "consult-room-review-invite",
  roomInviteDone: "consult-room-review-done",

  // tenant admin (ReviewsAdmin.jsx)
  adminPage: "reviews-admin",
  adminLoadError: "reviews-admin-load-error",
  adminEmpty: "reviews-admin-empty",
  adminSummary: "reviews-admin-summary",
  adminRow: (id) => `reviews-admin-row-${id}`,
  adminReplyInput: (id) => `reviews-admin-reply-input-${id}`,
  adminReplySubmit: (id) => `reviews-admin-reply-submit-${id}`,
  adminReplyText: (id) => `reviews-admin-reply-text-${id}`,
  adminFlagButton: (id) => `reviews-admin-flag-${id}`,
  adminFlagReason: "reviews-admin-flag-reason",
  adminFlagSubmit: "reviews-admin-flag-submit",
  adminFlaggedPill: (id) => `reviews-admin-flagged-${id}`,
  adminHiddenPill: (id) => `reviews-admin-hidden-${id}`,
  adminFilterFlagged: "reviews-admin-filter-flagged",

  // super admin (ReviewsModeration.jsx)
  saPage: "sa-reviews",
  saLoadError: "sa-reviews-load-error",
  saEmpty: "sa-reviews-empty",
  saTabReviews: "sa-reviews-tab-reviews",
  saTabSettings: "sa-reviews-tab-settings",
  saRow: (id) => `sa-review-row-${id}`,
  saHide: (id) => `sa-review-hide-${id}`,
  saUnhide: (id) => `sa-review-unhide-${id}`,
  saHiddenPill: (id) => `sa-review-hidden-${id}`,
  saHideReason: "sa-review-hide-reason",
  saHideConfirm: "sa-review-hide-confirm",
  saFilterTenant: "sa-reviews-filter-tenant",
  saPractice: (tid) => `sa-reviews-practice-${tid}`,
  saPracticeToggle: (tid) => `sa-reviews-practice-toggle-${tid}`,
  saPracticeReviews: (tid) => `sa-reviews-practice-reviews-${tid}`,
  saPracticeMarketplace: (tid) => `sa-reviews-practice-marketplace-${tid}`,
  saPracticeLoadError: (tid) => `sa-reviews-practice-load-error-${tid}`,
  saFilterHidden: "sa-reviews-filter-hidden",
  saFilterFlagged: "sa-reviews-filter-flagged",
  saProgramForm: "sa-reviews-program",
  saProgramEnabled: "sa-reviews-program-enabled",
  saProgramStartedAt: "sa-reviews-program-started-at",
  saProgramPriorWeight: "sa-reviews-program-prior-weight",
  saProgramTokenTtl: "sa-reviews-program-token-ttl",
  saProgramSave: "sa-reviews-program-save",
  saProgramError: "sa-reviews-program-error",
});
